import { render, staticRenderFns } from "./PersonalPopup.vue?vue&type=template&id=3e48c510&scoped=true&"
import script from "./PersonalPopup.vue?vue&type=script&lang=ts&"
export * from "./PersonalPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalPopup.vue?vue&type=style&index=0&id=3e48c510&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48c510",
  null
  
)

export default component.exports